import { UserInfoBuilder } from './user-info.builder';
var TicketInfoBuilder = /** @class */ (function () {
    function TicketInfoBuilder() {
        this.item = {
            id: 'b0000b0b-b0b0-b0b0-b0b0-b0bb0bb00b0b',
            subject: 'ticket subject',
            locale: 'en',
            userInfo: new UserInfoBuilder().build(),
            assignedGroupId: 'b0000b0b-b0b0-b0b0-b0b0-b0bb0bb00b0b',
            skillIds: ['b0000b0b-b0b0-b0b0-b0b0-b0bb0bb00b0b']
        };
    }
    TicketInfoBuilder.prototype.withId = function (id) {
        this.item.id = id;
        return this;
    };
    TicketInfoBuilder.prototype.withSubject = function (subject) {
        this.item.subject = subject;
        return this;
    };
    TicketInfoBuilder.prototype.withLocale = function (locale) {
        this.item.locale = locale;
        return this;
    };
    TicketInfoBuilder.prototype.withUserInfo = function (userInfo) {
        this.item.userInfo = userInfo;
        return this;
    };
    TicketInfoBuilder.prototype.withAssignedGroupId = function (assignedGroupId) {
        this.item.assignedGroupId = assignedGroupId;
        return this;
    };
    TicketInfoBuilder.prototype.withSkillIds = function (skillIds) {
        this.item.skillIds = skillIds;
        return this;
    };
    TicketInfoBuilder.prototype.build = function () {
        return this.item;
    };
    return TicketInfoBuilder;
}());
export { TicketInfoBuilder };
//# sourceMappingURL=ticket-info.builder.js.map